import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {
    ButtonModule,
    CarouselModule,
    CheckboxModule,
    ChipsModule,
    ConfirmDialogModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    EditorModule,
    GrowlModule,
    InputTextModule,
    MessagesModule,
    PaginatorModule,
    PanelModule,
    TooltipModule,
} from 'primeng/primeng';

import {
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
} from '@angular/material';

import {FlexLayoutModule} from '@angular/flex-layout';


import {FileUploadModule} from '../core/commons/file-upload-input/file-upload-input.component';
import {DictamenesComponent} from './component/dictamenes/dictamenes.component';
import {DictamenesListComponent} from './component/dictamenes/dictamenes-list/dictamenes-list.component';
import {DictamenesFormComponent} from './component/dictamenes/dictamenes-form/dictamenes-form.component';
import {CategoriaFormComponent} from './component/dictamenes/categoria/categoria-form/categoria-form.component';
import {CategoriaComponent} from './component/dictamenes/categoria/categoria.component';
import {CategoriaListComponent} from './component/dictamenes/categoria/categoria-list/categoria-list.component';
import {HomeFiscaliaComponent} from './component/home-fiscalia/home-fiscalia.component';
import {WordpressPostListComponent} from './component/news/wordpress-post-list/wordpress-post-list.component';
import {WordpressPostComponent} from './component/news/wordpress-big-post/wordpress-big-post.component';
import {WordpressLittePostComponent} from './component/news/wordpress-litte-post/wordpress-litte-post.component';
import {FXDirectiveModule} from '../directives/fx.directive';
import {AbogadosService} from './service/abogados.service';
import {MinistryAreaService} from '../profile/service/ministry-area.service';
import {MinistryService} from '../profile/service/ministry.service';
import {MessageEditorComponent} from './component/message-editor/message-editor.component';
import {ValidationMessagesModule} from '../core/validation-messages/validation-messages.module';
import {TopicComponent} from './component/forum/topic/topic.component';
import {TopicListComponent} from './component/forum/topic/topic-list/topic-list/topic-list.component';
import {PostComponent} from './component/forum/post/post.component';
import {TopicFormComponent} from './component/forum/topic/topic-form/topic-form.component';
import {PostListComponent} from './component/forum/post/post-list/post-list.component';
import {PostDetailComponent} from './component/forum/post/post-destail/post-detail.component';
import {ReplyListComponent} from './component/forum/post/reply-list/reply-list.component';
import {CommentListComponent} from './component/forum/post/comment-list/comment-list.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReplyFormComponent} from './component/forum/post/reply-form/reply-form.component';
import {TopicFilterComponent} from './component/forum/topic/topic-filter/topic-filter.component';
import {NavigationBarComponent} from './component/forum/navigation-bar/navigation-bar.component';
import {PostFormComponent} from './component/forum/post/post-form/post-form.component';
import {ConversationListComponent} from './component/chat/conversation-list/conversation-list.component';
import {MessageBoxComponent} from './component/chat/message-box/message-box.component';
import {ChatComponent} from './component/chat/chat.component';
import {ConversationService} from './service/chat/conversation.service';
import {MessageService} from './service/chat/message.service';
import {UserRequestComponent} from './component/user-request/user-request.component';
import {DocumentCategoryListComponent} from './component/repository/document-category/list/document-category-list.component';
import {DocumentCategoryComponent} from './component/repository/document-category/document-category.component';
import {RepositoryComponent} from './component/repository/repository.component';
import {DocumentCategoryFormComponent} from './component/repository/document-category/form/document-category-form.component';
import {CategoryExplorerComponent} from './component/repository/explorer/category-explorer/category-explorer.component';
import {DocumentExplorerComponent} from './component/repository/explorer/document-explorer/document-explorer.component';
import {SubCategoriesListComponent} from './component/repository/explorer/category-explorer/sub-categories-list/sub-categories-list.component';
import {DocumentCategoryService} from './service/repository/document-category.service';

import {RepositoryExplorerComponent} from './component/repository/explorer/explorer.component';
import {DocumentService} from './service/repository/document.service';
import {DocumentFormComponent} from './component/repository/explorer/document-form/document-form.component';
import {FileUploaderComponent} from '../core/commons/file-upload/file-upload.component';
import {CategoryFormComponent} from './component/repository/explorer/category-form/category-form.component';
import {MinistriesComponent} from './component/ministries/ministries.component';
import {MinistryListComponent} from './component/ministries/ministry-list/ministry-list.component';
import {MinistryFormComponent} from './component/ministries/ministry-form/ministry-form.component';
import {ProvinceService} from '../profile/service/province.service';
import {CityService} from '../profile/service/city.service';
import {PdfViewerComponent} from './component/repository/explorer/pdf-viewer/pdf-viewer.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {AbogadosProfilesComponent} from './component/abogados-profiles/abogados-profiles.component';
import {AbogadosProfilesListComponent} from './component/abogados-profiles/abogados-profiles-list/abogados-profiles-list.component';
import {AbogadosProfileService} from './service/abogados-profile.service';
import {AbogadosProfilesDetailComponent} from './component/abogados-profiles/abogados-profiles-detail/abogados-profiles-detail.component';
import {ReportErrorsComponent} from './component/report-errors/report-errors.component';
import {ReportErrorService} from './service/report-error.service';
import {BowserModule, BowserService} from 'ngx-bowser';
import {FormViewsModule} from '../form-views/form-views.module';
import {CoreModule} from '../core/core.module';


// @ts-ignore
@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        BrowserAnimationsModule,
        DataTableModule,
        ButtonModule,
        InputTextModule,
        ReactiveFormsModule,
        RouterModule,
        TooltipModule,
        MessagesModule,
        GrowlModule,
        ConfirmDialogModule,
        DialogModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        ChipsModule,
        FileUploadModule,
        PanelModule,
        CarouselModule,
        CheckboxModule,
        PaginatorModule,
        FXDirectiveModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatCardModule,
        MatToolbarModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatTabsModule,
        MatButtonModule,
        MatListModule,
        MatDialogModule,
        MatTooltipModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        EditorModule,
        MatMenuModule,
        ValidationMessagesModule,
        EditorModule,
        CheckboxModule,
        FXDirectiveModule,
        FlexLayoutModule,
        MatChipsModule,
        PdfViewerModule,
        BowserModule,
        MatAutocompleteModule,
        FormViewsModule
    ],
    entryComponents: [PdfViewerComponent],
    declarations: [
        DictamenesComponent,
        DictamenesListComponent,
        DictamenesFormComponent,
        CategoriaFormComponent,
        CategoriaListComponent,
        CategoriaComponent,
        WordpressPostListComponent,
        WordpressPostComponent,
        HomeFiscaliaComponent,
        WordpressLittePostComponent,
        MessageEditorComponent,
        TopicComponent,
        TopicListComponent,
        PostComponent,
        TopicFormComponent,
        PostListComponent,
        PostDetailComponent,
        ReplyListComponent,
        CommentListComponent,
        ReplyFormComponent,
        TopicFilterComponent,
        NavigationBarComponent,
        PostFormComponent,
        ConversationListComponent,
        MessageBoxComponent,
        ChatComponent,
        UserRequestComponent,
        DocumentCategoryListComponent,
        DocumentCategoryComponent,
        RepositoryComponent,
        DocumentCategoryFormComponent,
        RepositoryExplorerComponent,
        CategoryExplorerComponent,
        DocumentExplorerComponent,
        SubCategoriesListComponent,
        DocumentFormComponent,
        FileUploaderComponent,
        CategoryFormComponent,
        MinistriesComponent,
        MinistryListComponent,
        MinistryFormComponent,
        PdfViewerComponent,
        AbogadosProfilesComponent,
        AbogadosProfilesListComponent,
        AbogadosProfilesDetailComponent,
        ReportErrorsComponent
    ],
    providers: [
        AbogadosService,
        MinistryService,
        MinistryAreaService,
        ProvinceService,
        CityService,
        ConversationService,
        MessageService,
        DocumentCategoryService,
        DocumentService,
        ReportErrorService,
        BowserService,
        AbogadosProfileService
    ],
    exports: [
        RepositoryExplorerComponent
    ]
})
export class FiscaliaModule {
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/fiscalia.module.ts